import React from 'react';

import Menu from '../Menu';
import { menuLinks, sections, bestPracticesDefault } from './../constants'
import ils_19 from './../images/assets/ils_19.svg';

import ServiceContent from './ServiceContent';

const title = sections.services.machineLearning.page.title
const description = 'Apply modern Machine Learning approaches to drive business growth and operational efficiency. We leverage ensemble methods, AutoML, and explainable AI to build interpretable and high-performing models. From customer analytics to fraud detection, our ML solutions integrate seamlessly with your existing systems and provide real-time predictions with A/B testing frameworks for continuous optimization.'
const useCases = [
	'Customer behavior segmentation with clustering algorithms',
	'Churn prediction and prevention with proactive interventions',
	'Customer Lifetime Value (CLV) modeling and optimization',
	'Dynamic pricing optimization with reinforcement learning',
	'Fraud detection with real-time anomaly detection',
	'Personalized recommendation engines with collaborative filtering',
	'Cohort analysis and retention optimization',
	'A/B testing frameworks for ML model evaluation'
]
const bestPractices = bestPracticesDefault.concat([
	'Explainable AI (XAI) for model interpretability and trust',
	'Ensemble methods for robust predictions',
	'Real-time prediction APIs with low latency',
	'A/B testing frameworks for continuous model improvement',
	'AutoML for rapid model prototyping and baseline establishment'
])

const faqs = [
	{
		question: "What is Explainable AI (XAI) and why is it important for business?",
		answer: "Explainable AI (XAI) provides human-understandable explanations for machine learning model predictions. This is critical for business decisions where stakeholders need to understand why a model made a specific prediction, for regulatory compliance, and for building trust in AI systems. CaptainMe AI uses techniques like SHAP values and LIME to make model decisions transparent."
	},
	{
		question: "How does Customer Lifetime Value (CLV) modeling work?",
		answer: "CLV modeling uses machine learning to predict the total revenue a business can expect from a customer over their entire relationship. CaptainMe AI builds CLV models using purchase history, engagement patterns, and behavioral segmentation to identify high-value customers, optimize marketing spend, and personalize retention strategies."
	}
]

function ServicesMachineLearning() {
	return (
		<React.Fragment>
			< Menu />

			<ServiceContent
				pageTitle='Machine Learning'
				title={title}
				description={description}
				img={ils_19}
				useCases={useCases}
				bestPractices={bestPractices}
				breadCrumpMenu={sections.services.machineLearning.title}
				currentMenuPage={menuLinks.servicesMachineLearning}
				faqs={faqs}
			/>

		</React.Fragment>
	)
}

export default ServicesMachineLearning;
